import { supabase } from '@/integrations/supabase/client';
import type { CleanupFilters, CleanupPreview } from '@/types/notifications';

// Get preview of what would be cleaned up (dry run)
export const getCleanupPreview = async (filters: CleanupFilters): Promise<CleanupPreview> => {
  try {
    const { data, error } = await supabase.rpc('cleanup_notification_history', {
      p_before_date: filters.before_date || null,
      p_template_id: filters.template_id || null,
      p_campaign_id: filters.campaign_id || null,
      p_status_filter: filters.status_filter || null,
      p_dry_run: true,
    });

    if (error) throw error;

    return {
      delivery_count: data?.delivery_count || 0,
      mapping_count: data?.mapping_count || 0,
      attempt_count: data?.attempt_count || 0,
    };
  } catch (error) {
    console.error('Error getting cleanup preview:', error);
    throw error;
  }
};

// Execute cleanup (actual deletion)
export const executeCleanup = async (filters: CleanupFilters): Promise<CleanupPreview> => {
  try {
    const { data, error } = await supabase.rpc('cleanup_notification_history', {
      p_before_date: filters.before_date || null,
      p_template_id: filters.template_id || null,
      p_campaign_id: filters.campaign_id || null,
      p_status_filter: filters.status_filter || null,
      p_dry_run: false,
    });

    if (error) throw error;

    return {
      delivery_count: data?.delivery_count || 0,
      mapping_count: data?.mapping_count || 0,
      attempt_count: data?.attempt_count || 0,
    };
  } catch (error) {
    console.error('Error executing cleanup:', error);
    throw error;
  }
};
